import type { FeatureFlags } from "./types";

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  // Table implementation flags - Start with tasks enabled
  useNewTasksImplementation: true,
  useNewContactsImplementation: false,
  useNewTimeEntriesImplementation: false,
  useNewTicketsImplementation: false,
  useNewCompaniesImplementation: false,
  useNewContractsImplementation: false,
  useNewUsersImplementation: false,
  useNewReportsImplementation: false,
  useNewMessagesImplementation: false,

  // Generic component flags
  useGenericForms: true,
  useGenericTableComponents: true,

  // Feature-specific flags
  enableAdvancedFiltering: true,
  enableBulkActions: true,
  enableSavedViews: true,
  enableExport: true,
  enableImport: true,
  enableInfiniteScroll: true,
  enableVirtualization: true,
  enableColumnResizing: true,
  enableColumnVisibility: true,
  enableMultiColumnSort: true,

  // Report-related flags (for existing code compatibility)
  canViewReports: true,
  canExportReports: true,
  showAdvancedFilters: true,
  canViewBillingReports: true,

  // Dashboard and navigation flags
  canViewDashboard: true,
  canViewTickets: true,
  canViewInternalTickets: true,
  canCreateTickets: true,
  canUseTicketTemplates: true,
  showTimeTrackingMenu: true,
  canViewAllTimeEntries: true,
  canCreateTimeEntries: true,
  showClientMenu: true,
  canViewClients: true,
  canCreateClients: true,
  showAdminMenu: true,
  canViewUsers: true,
  canManageAutomation: true,
  canManageData: true,
  canManageSystemSettings: true,

  // Task-related flags
  canViewTasks: true,
  canCreateTasks: true,
  canEditTasks: true,
  canDeleteTasks: true,
  canAssignTasks: true,
  canChangeTaskStatus: true,
  canChangeTaskPriority: true,
  canViewAllTasks: true,
  canViewMyTasks: true,
  canExportTasks: true,

  // Development flags
  enableDebugMode: process.env.NODE_ENV === "development",
  enablePerformanceMonitoring: false,
  enableErrorBoundaries: true,

  // Support chat flag
  supportChat: process.env.NEXT_PUBLIC_FEATURE_FLAG_SUPPORT_CHAT === "true",
};
